<template>
  <v-system-bar
    v-if="authStore.impersonationActive"
    color="warning"
    variant="tonal"
    class="impersonation-banner"
  >
    <v-icon icon="mdi-alert" class="mr-2" />
    <span class="font-weight-bold text-truncate">Impersonation Mode</span>
    <v-spacer />
    <span class="font-weight-bold ml-4">Tenant: </span>
    <span class="ml-2 text-truncate"> {{ authStore.userData?.company }}</span>
    <span class="font-weight-bold ml-4">User:</span>
    <span class="ml-2 text-truncate"> {{ authStore.userData?.email }}</span>
    <span class="font-weight-bold ml-4">UID:</span>
    <span class="text-caption text-truncate">{{ authStore.userData?.uid }}</span>

    <v-spacer />
    <v-btn variant="text" density="compact" color="white" @click="stopImpersonation" class="ml-2">
      <v-icon icon="mdi-logout" class="mr-1" />
      Exit Impersonation
    </v-btn>
  </v-system-bar>
</template>

<script>
import { useAuthStore } from '@/store/auth'
import { mapStores } from 'pinia'
import { log } from '@/plugins/logger'

export default {
  name: 'ImpersonationBanner',

  computed: {
    ...mapStores(useAuthStore)
  },

  methods: {
    async stopImpersonation() {
      try {
        const success = await this.authStore.stopImpersonation()

        if (success) {
          this.$router.push('/support-impersonation')
        }
      } catch (error) {
        log.error('Error stopping impersonation:', error)
      }
    }
  }
}
</script>

<style scoped>
.impersonation-banner {
  position: sticky;
  top: 0;
  z-index: 1000;
  font-size: 14px;
}
</style>
